import React, { useEffect, useRef } from 'react';
import { useRouter } from 'next/router';
import { startHeartbeat, setModalCallback } from './sessionHeartbeat';
import { setSessionToken } from './sessionUtils';
import useDialogs from '@/hooks/useDialogs';

export default function SessionHeartbeatProvider({ children, subdomain, sessionToken }) {
  const router = useRouter();
  const heartbeatInitialized = useRef(false);
  const { confirmBackCode } = useDialogs();

  useEffect(() => {
    if (sessionToken && subdomain && !heartbeatInitialized.current) {
      setSessionToken(sessionToken);
      
      heartbeatInitialized.current = true;
      const cleanup = startHeartbeat(subdomain);
      
      return () => {
        cleanup();
        heartbeatInitialized.current = false;
      };
    }
  }, [sessionToken, subdomain]);

  useEffect(() => {
    setModalCallback((code) => {
      if (code === 'INVALID_SESSION_TOKEN') {
        confirmBackCode(code);
      }
    });
  }, [confirmBackCode]);

  return children;
} 